

import { useEffect, useRef, useState } from "react";

// Styles
import "../../../QrStyles.css";

// Qr Scanner
import QrScanner from "qr-scanner";
import QrFrame from "./qr-frame.svg";
import sound from "../../page/sound/beep.mp3";

const QrReader = ({setIsQRReader, setShowQRReader, selectedSize, submitVT}) => {
    // QR States
    const scanner = useRef(null);
    const videoEl = useRef(null);
    const qrBoxEl = useRef(null);
    const [qrOn, setQrOn] = useState(true);

    const timeout = useRef();

    const handleDebounceSearch = (result) => {
        //Clear the previous timeout.
        clearTimeout(timeout.current)

        // // If there is no search term, do not make API call
        // if (!newInputValue.trim()) {
        //     setOptions([])
        //     return
        // }
        timeout.current = setTimeout(() => {
            submitVT(selectedSize, result);
            setShowQRReader(false);
        }, 2000);
    };

    // Result
    const [scannedResult, setScannedResult] = useState(null);

    // Success
    const onScanSuccess = (result) => {
        // 🖨 Print the "result" to browser console.
        //console.log(result);
        // ✅ Handle success.
        // 😎 You can do whatever you want with the scanned result.
        if(null == scannedResult){
            setScannedResult(result?.data);
            // submitVT(selectedSize, result.data);
            // setShowQRReader(false);
        }
        // else {
        //     console.log("FFFFFFFFFFFFAAAAAAAAIIIIIIILLLLLLLLL");
        //     submitVT(selectedSize, null);
        //     setShowQRReader(false);
        // }
    };

    // Fail
    const onScanFail = (err) => {
        // 🖨 Print the "err" to browser console.
        //console.log(err);
        // console.log("EEEEEEEERRRRRRRRROOOOOOOOORRRRR");
        // submitVT(selectedSize, null);
        // setShowQRReader(false);
    };

    useEffect(() => {
        if (videoEl?.current && !scanner.current) {
            // 👉 Instantiate the QR Scanner
            scanner.current = new QrScanner(videoEl?.current, onScanSuccess, {
                onDecodeError: onScanFail,
                // 📷 This is the camera facing mode. In mobile devices, "environment" means back camera and "user" means front camera.
                preferredCamera: "environment",
                // 🖼 This will help us position our "QrFrame.svg" so that user can only scan when qr code is put in between our QrFrame.svg.
                highlightScanRegion: true,
                // 🔥 This will produce a yellow (default color) outline around the qr code that we scan, showing a proof that our qr-scanner is scanning that qr code.
                highlightCodeOutline: true,
                // 📦 A custom div which will pair with "highlightScanRegion" option above 👆. This gives us full control over our scan region.
                overlay: qrBoxEl?.current || undefined,
            });

            // 🚀 Start QR Scanner
            scanner?.current
                ?.start()
                .then(() => setQrOn(true))
                .catch((err) => {
                    if (err) setQrOn(false);
                });
        }

        // 🧹 Clean up on unmount.
        // 🚨 This removes the QR Scanner from rendering and using camera when it is closed or removed from the UI.
        return () => {
            if (!videoEl?.current) {
                scanner?.current?.stop();
            }
        };
    }, []);

    // ❌ If "camera" is not allowed in browser permissions, show an alert.
    useEffect(() => {
        if (!qrOn) {
            alert(
                "Camera was blocked or not accessible. Please enabled the camera permissions and try again."
            );
            // setIsQRReader(false);
            setShowQRReader(false);
        }
    }, [qrOn]);

    useEffect(() => {
        if(null != scannedResult) {
            console.log("SSSSSSSSCCCCCCCCAAAAAAAANNNNNNN");
            console.log(scannedResult);
            handleDebounceSearch(scannedResult);
            new Audio(sound).play();
        }
    }, [scannedResult]);

    return (
        <div className="qr-reader">
            {/* QR */}
            <video ref={videoEl}></video>
            <div ref={qrBoxEl} className="qr-box">
                <img
                    src={QrFrame}
                    alt="Qr Frame"
                    width={256}
                    height={256}
                    className="qr-frame"
                />
            </div>

            {/* Show Data Result if scan is success */}
            {/*{scannedResult && (*/}
            {/*    <p*/}
            {/*        style={{*/}
            {/*            position: "absolute",*/}
            {/*            top: 0,*/}
            {/*            left: 0,*/}
            {/*            zIndex: 99999,*/}
            {/*            color: "white",*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        Scanned Result: {scannedResult}*/}
            {/*    </p>*/}
            {/*)}*/}
        </div>
    );
};

export default QrReader;